import { render, staticRenderFns } from "./AccessControlConfiguration.vue?vue&type=template&id=8e2b3e7c&scoped=true&"
import script from "./AccessControlConfiguration.vue?vue&type=script&lang=js&"
export * from "./AccessControlConfiguration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e2b3e7c",
  null
  
)

export default component.exports